module.exports = __webpack_public_path__ + "img/clientes_2.58936e76.png";